export default defineNuxtPlugin(async (nuxtApp) => {
  const { initializeDatabase } = usePosDatabase()

  console.log('[Plugin] Initializing POS database before app starts...')

  try {
    await initializeDatabase()
    console.log('[Plugin] POS database initialized successfully')
  } catch (err) {
    console.error('[Plugin] Failed to initialize POS database:', err)
    throw err
  }
})
